const DEFAULT_WIDTHS = [400, 600, 800];

export function shopifySrcSet(
  baseUrl: string,
  widths: number[] = DEFAULT_WIDTHS,
): string {
  return widths
    .map((w) => `${baseUrl}&width=${w}&format=auto&quality=100 ${w}w`)
    .join(', ');
}
